export default __webpack_public_path__ + "02273c328cce755b27801921119bee47.png";